var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./SelectClient.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?{\"id\":\"data-v-2ab66919\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./SelectClient.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/client/SelectClient.vue
// module id = 65
// module chunks = 1